import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=5daabc54"
import script from "./CustomDashboard.vue?vue&type=script&lang=js"
export * from "./CustomDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomDashboard.vue?vue&type=style&index=0&id=5daabc54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports